import { combineReducers } from "redux"
import { reducer as form } from "redux-form"
import { pendingTasksReducer } from "react-redux-spinner"
import authReducer from "./auth_reducer"
import venueReducer from "./venue_reducer"
import venueListReducer from "./venue_list_reducer"
import eventReducer from "./event_reducer"
import eventListReducer from "./event_list_reducer"
import notificationReducer from "./notification_reducer"
import notificationListReducer from "./notification_list_reducer"

const rootReducer = combineReducers({
  pendingTasks: pendingTasksReducer,
  form,
  auth: authReducer,
  event: eventReducer,
  venue: venueReducer,
  notification: notificationReducer,
  venueList: venueListReducer,
  eventList: eventListReducer,
  notificationList: notificationListReducer
})

export default rootReducer



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/